module.exports = __webpack_public_path__ + "static/media/football.0bb439ce.png";